import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const TabSwitch = (props) => {

  //#region props
  const { tabs,selectedTab,setSelectedTab } = props;

  const [value, setValue] = React.useState(selectedTab || 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if(setSelectedTab){
        setSelectedTab();
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
           {tabs.map((tab, index) => (
                <Tab
                  label={
                    <div className='child-row-margin-5 align-items-center'>
                        {tab.icon}
                      <span className='margin-left-10'>{tab.label}</span>
                    </div>
                  }
                    {...a11yProps(index)} 
                    key={index} 
                  />
                ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
                <CustomTabPanel value={value} index={index} key={index}>
                  {tab.component}
                </CustomTabPanel>
        ))}
    </Box>
  );
}

export default TabSwitch;
